export default __webpack_public_path__ + "static/media/wakanda3.ffbb7d13.jpg";